/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import Text from 'src/components/ts-components/Text'

/**
 * Why a player cannot change their team on register-entity: they joined a
 * PRIVATE team, which is reachable only through the link they followed.
 *
 * A sentence and nothing else. The team and division themselves are already
 * stated in the summary card above it, so repeating them here would be a second
 * read-only copy of the same facts.
 */
const PrivateTeamNotice = () => (
  <div css={noticeStyle} data-testid='private-team-notice'>
    <Text variant='paragraphSmall' color={colors.NEUTRAL_50} weight='regular'>
      You followed a private team link, so your team and division are already
      set.
    </Text>
  </div>
)

export default PrivateTeamNotice

const noticeStyle = css`
  align-self: stretch;
  margin-top: 16px;
`
